import React, { memo, NamedExoticComponent } from 'react'
import { EllipsisTooltipText } from 'apps/marketplace/pages/shipment-details/components/EllipsisTooltipText'

interface IUserLinkProps {
  className?: string
  id: string
  name: string
  dataTest?: string
  maxCharacters?: number
}
export const UserLink: NamedExoticComponent<IUserLinkProps> = memo(
  ({ className, dataTest, id, maxCharacters, name }) => (
    <span className={className} data-test={dataTest}>
      <a href={`${__ROOT__}/users/${id}`} target='_blank' rel='noopener noreferrer'>
        {Number.isInteger(maxCharacters) ? (
          <EllipsisTooltipText
            text={name}
            maxCharacters={maxCharacters}
            TooltipProps={{ position: 'right' }}
          />
        ) : (
          name
        )}
      </a>
    </span>
  )
)
